import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { IMultiSelectOption } from 'angular-2-dropdown-multiselect';

@Component({
  selector: 'app-select-field',
  templateUrl: './select-field.component.html',
  styleUrls: ['./select-field.component.css']
})
export class SelectFieldComponent implements OnInit {

  @Input() data;
  @Output() dataChange = new EventEmitter<string>();

  @Input() _errors: string[];
  @Input() label: string;
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() options: IMultiSelectOption[];

  settings = {
    enableSearch: true,
    closeOnSelect: true,
    checkedStyle: 'fontawesome',
    containerClasses: 'width100p dropdown-inline',
    buttonClasses: 'btn btn-block',
    selectionLimit: 1,
    autoUnselect: true,
  };

  constructor() {
  }

  ngOnInit() {
  }

  @Input()
  set errors(errors) {
    console.log(errors);
    this._errors = errors;
    if (this._errors) {
      this.settings.buttonClasses = 'btn btn-block btn-outline-danger';
      this.settings = Object.assign({}, this.settings);
    } else {
      this.settings.buttonClasses = 'btn btn-block btn-outline-info';
    }
    console.log(this.settings);
  }

  change($event) {
    this.dataChange.emit($event);
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/components/select-field/select-field.component.ts